import { useMediaQuery } from "@mui/material";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import TableViewResumo from "./TableViewResumo";
import CardViewResumo from "./CardViewResumo";
import { GridLoader } from "react-spinners";
import Header from "./Header/Header";
import Loading from "../Loading";

const TableCardResumo = ({
  header,
  debounce,
  complementaryHeaderTop,
  complementaryHeaderBottom,
  handleGrupoEmpresa,
  hasEmpresa,
  uniqueEmpresa,
  selectedAllEmpresas,
  columns,
  data,
  loading,
  versaoId,
}) => {
  const minDesktop = useMediaQuery("(max-width: 900px)");
  const [view, setView] = useState(minDesktop ? "grid" : "table");

  const hasBotoes = data.some((item) => item.hasOwnProperty("btn"));

  useEffect(() => {
    setView(minDesktop ? "grid" : "table");
  }, [minDesktop]);

  const handleChangeView = (name) => {
    setView(name);
  };

  return (
    <div className={styles.container}>
      <div className={styles.paper}>
        {!loading && (
          <Header
            header={header}
            debounce={debounce}
            hasEmpresa={hasEmpresa}
            handleGrupoEmpresa={handleGrupoEmpresa}
            complementaryHeaderTop={complementaryHeaderTop}
            complementaryHeaderBottom={complementaryHeaderBottom}
            selectedAllEmpresas={selectedAllEmpresas}
            uniqueEmpresa={uniqueEmpresa}
            view={view}
            handleChangeView={handleChangeView}
          />
        )}
        {loading ? (
          <Loading loading={loading} />
        ) : (
          <div className={styles.containerTable}>
            {data.length > 0 ? (
              view === "table" ? (
                <TableViewResumo
                  columns={columns}
                  data={data}
                  hasBotoes={hasBotoes}
                />
              ) : (
                <CardViewResumo
                  columns={columns}
                  data={data}
                  hasBotoes={hasBotoes}
                />
              )
            ) : (
              <h3 className={styles.noData}>
                {" "}
                <GridLoader
                  color="#18316e"
                  loading={true}
                  size={5}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                ></GridLoader>
                Nenhum item encontrado!
              </h3>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableCardResumo;
